export default __webpack_public_path__ + "static/media/AE_FlipCard.070a4150.webp";